export default {

    data(){
        return {}
    },
    methods:{
        $fileExtension(fileName){
          
          if(!fileName) return fileName;
            return fileName.split('.').pop()?.toLowerCase();
        },
         $formatFileSize(bytes,decimalPoint) {
            if(bytes == 0) return '0 Bytes';
            var k = 1000,
                dm = decimalPoint || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
         },
         $download(url, filename) {
            fetch(url)
              .then((response) => response.blob())
              .then((blob) => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
              })
              .catch(console.error)
              .finally(() => {
                this.downloadingFileName = '';
              });
          }
    }
}